import React from 'react';
import PropTypes from 'prop-types';

const Reported = (
    {
        width = 26,
        height = 26,
    }) =>

    <svg width={width} height={height} viewBox="0 0 347 347" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(10 -37)" fill="none" fillRule="evenodd"><ellipse stroke="#3F53CA" strokeWidth="20" fill="#FFF" cx="163.5" cy="210.5" rx="163.5" ry="163.5"/><text fontFamily="Arial-Black, Arial Black" fontSize="288" fontWeight="700" fill="#000"><tspan x="67.453" y="317">5</tspan></text></g>
    </svg>

Reported.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
}

export default Reported



// WEBPACK FOOTER //
// ./src/components/Icon/svg/reported.js